"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entitySelectTransform = void 0;
var entitySelectTransform = function (entity, _a) {
  var icons = _a.icons,
    useSlugForValue = _a.useSlugForValue;
  var name = entity.name,
    slug = entity.slug,
    isDraft = entity.isDraft,
    _optionLabel = entity._optionLabel,
    id = entity.id,
    openGraph = entity.openGraph,
    __typename = entity.__typename;
  // @ts-ignore 
  var description = entity.description && entity.description.text;
  return {
    label: _optionLabel || name,
    slug: slug,
    entity: entity,
    value: useSlugForValue ? slug : id,
    badge: isDraft && 'Draft',
    valueIcon: icons.Entities[__typename],
    // for performance let's not use icons for every option. If we eventually move to PNG fallbacks, this becomes feasible 
    description: openGraph && openGraph.description && openGraph.description.plain || description
  };
};
exports.entitySelectTransform = entitySelectTransform;